import moment from "moment";

import { HUMAN_READABLE_DATETIME_FORMAT } from "./constants";

const humanizeFromMilliseconds = (timestampInMilliseconds) =>
  moment(timestampInMilliseconds, "x")
    .utc()
    .format(HUMAN_READABLE_DATETIME_FORMAT);

const humanizeFromSeconds = (timestampInSeconds) =>
  moment(timestampInSeconds, "X").utc().format(HUMAN_READABLE_DATETIME_FORMAT);

export { humanizeFromMilliseconds, humanizeFromSeconds };
